module.exports = {
      id: "subnav-toggle--indicator-closed-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#subnav-toggle--indicator-closed-usage",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./client/src/site__evo/sprites/subnav-toggle--indicator-closed.svg
// module id = D:\a\1\s\node_modules\svg-sprite-loader\lib\loader.js??ref--14-0!D:\a\1\s\client\src\site__evo\sprites\subnav-toggle--indicator-closed.svg
// module chunks = site__evo